
    export default {
        name: 'BroughtTogetherTile',
        props: {
            src: {
                type: String,
                required: true
            }
        }
    }
